import { PACKAGE_CARD_TABS_KEYS } from 'legacyfrontend/constants';
import { usePackageCard } from 'legacyfrontend/contexts/PackageCardContext';
import { useTranslation } from 'react-i18next';
import { RiFlightTakeoffFill, RiHotelFill } from 'react-icons/ri';
import IconButton from '../IconButton';

const { FLIGHTS, HOTELS } = PACKAGE_CARD_TABS_KEYS;

const iconsByTab = {
  [FLIGHTS]: RiFlightTakeoffFill,
  [HOTELS]: RiHotelFill,
};

const PackageCardButton = ({ tabKey }) => {
  const { t } = useTranslation(['layout']);
  const { handleSelectedTab, selectedTab } = usePackageCard();

  return (
    <IconButton
      Icon={iconsByTab[tabKey]}
      className={selectedTab === tabKey ? 'active' : undefined}
      onClick={() => {
        handleSelectedTab(tabKey);
      }}
      text={t(`packages.list.button.${tabKey}`)}
    />
  );
};

export default PackageCardButton;
